import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Observable, of } from 'rxjs'
import { catchError, take, tap } from 'rxjs/operators'


export interface IBaseLoader {
  load<T>(value: string): Observable<T>
  startPreload(preLoads?: string[]): void
}

export abstract class AbstractBaseLoader implements IBaseLoader {
  public load<T>(value: string): Observable<T> {
    throw new Error('load not implement')
  }

  public startPreload(preLoads?: string[]): void {
    throw new Error('startPreload not implement')
  }

}

export class BaseLoader extends AbstractBaseLoader implements IBaseLoader {
  private readonly storage: Map<string, any> = new Map()

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: ((value: string) => string),
    private readonly preLoads: string[] = [],
    private readonly httpOption?: object
  ) {
    super()
  }

  public load<T>(value: string): Observable<T> {
    if (this.storage.has(value)) return of(this.storage.get(value))

    return this.http.get<T>(this.urlBuilder(value), this.httpOption).pipe(
      tap(model => this.storage.set(value, model)),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 404) console.error(`Model ${ value } not found`)
        console.error(err)
        return of(null)
      })
    )
  }

  public startPreload(preLoads: string[] = []): void {
    const list = [ ...this.preLoads, ...preLoads ]
    for (let i = 0; i < list.length; i++) {
      const name = list[i]
      if (this.storage.has(name)) continue
      this.load(name).pipe(
        take(1),
      ).subscribe()
    }
  }

}
